
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowType } from '../../../../util';
import { initClient } from '../../api';
import { AiDocumentsClient, AiDocument } from '../backend/backendapi';
import DropZone from '../dropzone/DropZone';

declare var window: WindowType;

@Component({
  name: 'UploadForm',
  components: {
    DropZone,
  }
})
export default class UploadFormAi extends Vue {
  private readonly api = initClient(AiDocumentsClient);
  tagValueUsedForTaggedDocs: string = "trvb";
  isSharedDoc: boolean = false;
  message: string = "";
  docs: AiDocument[] = [];
  loading: boolean = false;

  async mounted(): Promise<void> {
    await this.refreshList();
  }

  get uid(): string {
    return (this as any)._uid;
  }

  get dropzoneUrl(): string {
    return window.application.baseUrl + 'api/aidocuments/upload';
  }

  uploadedDone(): void {
    this.$emit('uploaded');
    const currentdate = new Date();
    const datetime = currentdate.getHours() + ":" +
      currentdate.getMinutes() + ":" +
      currentdate.getSeconds();
    this.message = 'Upload successful at:' + datetime;
  }

  async refreshList(): Promise<void> {
    this.loading = true;
    try {
      const result = await this.api.list();
      this.docs = result;
    } finally {
      this.loading = false;
    }
  }

  // Sorted view: show Processing documents first, then Failed, then others (Ready)
  get docsSorted() {
    return this.docs.slice().sort((a, b) => {
      const rank = (s?: string | null) => {
        if (!s) return 2;
        if (s === 'Processing') return 0;
        if (s === 'Failed') return 1;
        return 2; // Ready or other statuses
      };
      const ra = rank(a.processingStatus);
      const rb = rank(b.processingStatus);
      if (ra !== rb) return ra - rb;
      // Fallback to uploadedAt descending
      return new Date(b.uploadedAt).getTime() - new Date(a.uploadedAt).getTime();
    });
  }

  statusClass(status?: string | null) {
    if (!status) return 'ready';
    if (status === 'Processing') return 'processing';
    if (status === 'Failed') return 'failed';
    if (status === 'Ready') return 'ready';
    return 'ready';
  }

  downloadUrl(id: string) {
    return `TODO`;
  }

}
